import React from 'react';
import {HorizontalSliderControl} from '../HorizontalSlider/HorizontalSliderControl';
import {HorizontalSliderProps} from './HorizontalSlider';
import type {SliderControlProps} from './types';

export const HorizontalSliderHeaderControls: React.FC<
  SliderControlProps & {
    SlideControlComponent: HorizontalSliderProps['SlideControlComponent'];
  }
> = ({SlideControlComponent, ...rest}) => {
  if (SlideControlComponent) {
    return <SlideControlComponent {...rest} />;
  }

  return (
    <HorizontalSliderControl currentPage={rest.currentSlide + 1} {...rest} />
  );
};
